import { render } from "./IconMessage.vue?vue&type=template&id=84fa0904"
import script from "./IconMessage.vue?vue&type=script&lang=ts"
export * from "./IconMessage.vue?vue&type=script&lang=ts"
script.render = render

export default script